import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router'

export function useSmartBack(fallbackPath?: string) {
  const navigate = useNavigate()
  const location = useLocation()

  const hasHistory = location.key !== 'default'
  const canGoBack = !!fallbackPath || hasHistory

  const goBack = useCallback(() => {
    if (fallbackPath) {
      navigate(fallbackPath, { replace: true })
    } else if (hasHistory) {
      navigate(-1)
    } else {
      navigate('/', { replace: true })
    }
  }, [fallbackPath, hasHistory, navigate])

  return { goBack, canGoBack }
}
